/** Where a Review control sends the person: the Knowledge page's OKF tab with
 *  the review dialog open (`?review=1`). One definition, no imports, so the
 *  sidebar catalog can use it without pulling in a feature module. */
export const KNOWLEDGE_REVIEW_HREF = '/files?tab=okf&review=1';
